<router-outlet></router-outlet>
<bitf-loader></bitf-loader>
<ibm-placeholder></ibm-placeholder>
<div class="notification-container"></div>